/**
 * Interface pour les informations légales d'un utilisateur
 * Utilisé pour la conformité légale des factures d'artisans du bâtiment
 */
export interface LegalInfo {
  id?: number;

  // Assurance Décennale (Obligatoire)
  assuranceNom?: string;
  assuranceNumeroPolice?: string;
  assuranceCouvertureGeographique?: string;
  assuranceDateValidite?: string; // Format ISO: YYYY-MM-DD
  assuranceMontantGarantie?: number;

  // RC Professionnelle
  rcProAssuranceNom?: string;
  rcProNumeroPolice?: string;
  rcProDateValidite?: string; // Format ISO: YYYY-MM-DD

  // Identification juridique
  formeJuridique?: string; // SARL, SAS, Auto-entrepreneur, etc.
  capitalSocial?: string;
  rcs?: string; // RCS Paris 123 456 789
  rm?: string; // RM Paris 123 456 789 (artisans)

  // Conditions de paiement (Art. L.441-6)
  delaiPaiementJours?: number;
  tauxPenalitesRetard?: number;
  indemniteForfaitaireRecouvrement?: number;
  tauxEscompte?: number;
  delaiEscompteJours?: number;

  // Coordonnées bancaires
  iban?: string;
  bic?: string;
  nomBanque?: string;

  // Qualifications
  qualificationProfessionnelle?: string;
  mediateurConsommation?: string;
  mediateurSiteWeb?: string;

  // TVA spécifique
  franchiseTva?: boolean;
  agrementTvaReduite?: string;
}

/**
 * DTO pour la création/mise à jour des informations légales
 */
export interface LegalInfoDTO {
  // Assurance Décennale (Obligatoire)
  assuranceNom?: string;
  assuranceNumeroPolice?: string;
  assuranceCouvertureGeographique?: string;
  assuranceDateValidite?: string;
  assuranceMontantGarantie?: number;

  // RC Professionnelle
  rcProAssuranceNom?: string;
  rcProNumeroPolice?: string;
  rcProDateValidite?: string;

  // Identification juridique
  formeJuridique?: string;
  capitalSocial?: string;
  rcs?: string;
  rm?: string;

  // Conditions de paiement
  delaiPaiementJours?: number;
  tauxPenalitesRetard?: number;
  indemniteForfaitaireRecouvrement?: number;
  tauxEscompte?: number;
  delaiEscompteJours?: number;

  // Coordonnées bancaires
  iban?: string;
  bic?: string;
  nomBanque?: string;

  // Qualifications
  qualificationProfessionnelle?: string;
  mediateurConsommation?: string;
  mediateurSiteWeb?: string;

  // TVA spécifique
  franchiseTva?: boolean;
  agrementTvaReduite?: string;
}

/**
 * Options de formes juridiques pour les artisans
 */
export const FORMES_JURIDIQUES = [
  'Auto-entrepreneur / Micro-entreprise',
  'Entreprise Individuelle (EI)',
  'EIRL',
  'EURL',
  'SARL',
  'SAS',
  'SASU',
  'SA',
  'SNC',
  'Artisan',
  'Autre',
] as const;

export type FormeJuridique = typeof FORMES_JURIDIQUES[number];
